<template>
  <div class="store-home">
    <v-app-bar
      app
      color="primary"
      dense
      :class="[{ '' /*'desktop-mode-padding-left' */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col cols="2" class="d-flex">
          <v-app-bar-nav-icon v-if="showNavBack" @click="navBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>

          <v-app-bar-nav-icon x-v-if="!$vuetify.breakpoint.mdAndUp" @click="onClickMenu"></v-app-bar-nav-icon>

          <v-app-bar-nav-icon class="ml-4"
            v-if="/*!showNavBack && */ showLangSwitcher /* && !$vuetify.breakpoint.mdAndUp*/"
            @click="setNextLanguage"
          >
            <LanguageIcon></LanguageIcon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="8" class="d-flex justify-center"></v-col>

        <v-col cols="2" align-self="end" style="text-align: right">
          <!--           <v-badge
            :value="$store.state.order.qtyTotal"
            :content="$store.state.order.qtyTotal"
            color="accent"
            class="accentText--text"
            overlap
            offset-x="20"
            offset-y="20"
          >
            <v-app-bar-nav-icon @click="checkOutClicked">
              <v-icon>mdi-cart-outline</v-icon>
            </v-app-bar-nav-icon>
          </v-badge> -->
        </v-col>
      </v-row>
    </v-app-bar>

    <v-container v-if="$store.state.store != null">
      <img
        :src="$store.state.store.info.logoUri"
        class="home-logo"
        v-if="$store.state.store.info.logoUri != null && $store.state.store.info.logoUri != ''"
      />

      <div class="store-info">
        <div class="store-name">{{ $store.getters.storeName }}</div>
        <div v-if="$store.state.store.info.address !== undefined" class="store-address">
          <div v-if="$store.state.store.info.address.street !== undefined">
            <span
              v-if="
                $store.state.store.info.address.unit !== undefined &&
                  $store.state.store.info.address.unit != null &&
                  $store.state.store.info.address.unit != ''
              "
              >Unit {{ $store.state.store.info.address.unit }}, </span
            >{{ $store.state.store.info.address.street }}
          </div>
          <div v-if="$store.state.store.info.address.city !== undefined">
            {{ $store.state.store.info.address.city }}
          </div>
          <div v-if="$store.state.store.info.address.province !== undefined">
            {{ $store.state.store.info.address.province }}
          </div>
          <div v-if="$store.state.store.info.address.tel !== undefined">
            {{ $store.state.store.info.address.tel }}
          </div>
        </div>

        <div
          class="store-business-hours"
          v-if="
            $store.state.store.timeStatus !== undefined && $store.state.store.timeStatus.businessTimeLocaleString != ''
          "
        >
          <span>
            {{
              $t(
                $store.state.store.timeStatus.businessTimeLocaleString,
                $store.state.store.timeStatus.businessTimeParams
              )
            }}
            <span v-if="$store.state.store.timeStatus.timeZoneAbbrev != ''"
              >({{ $store.state.store.timeStatus.timeZoneAbbrev }})</span
            >
          </span>
        </div>
        <div
          class="store-order-hours"
          v-if="$store.state.store.timeStatus !== undefined && $store.state.store.timeStatus.preorderLocaleString != ''"
        >
          {{ $t($store.state.store.timeStatus.preorderLocaleString) }}
        </div>
      </div>

      <div
        v-if="$t('home-message') != '' && $t('home-message') != 'home-message'"
        class="home-message"
        v-html="$t('home-message')"
      >
        <!-- {{ $t("home-message") }} -->
      </div>

      <v-row class="order-button-container">
        <v-col class="item" v-if="storeDineinVisible">
          <v-btn class="order-button" @click="dineinOrder()">
            <v-col col-2>
              <v-badge
                :value="
                  $store.state.order.orderType == $store.state.OT_DINEIN && !$store.getters.storeMenuMode
                    ? $store.state.order.qtyTotal
                    : 0
                "
                :content="
                  $store.state.order.orderType == $store.state.OT_DINEIN && !$store.getters.storeMenuMode
                    ? $store.state.order.qtyTotal
                    : 0
                "
                color="accent"
                class="accentText--text"
                overlap
                offset-x="10"
                offset-y="10"
              >
                <v-icon>mdi-silverware-fork-knife</v-icon>
              </v-badge>
            </v-col>
            <v-row>
              <v-col>{{ $store.getters.storeDineinMenuMode ? $t("dinein.menu") : $t("dinein") }}</v-col>
            </v-row>
            <v-col col-2></v-col>
          </v-btn>
        </v-col>

        <v-col class="item" v-if="storeTakeoutVisible">
          <v-btn class="order-button" @click="takeoutOrder()">
            <v-col col-2>
              <v-badge
                :value="$store.state.order.orderType == $store.state.OT_TAKEOUT ? $store.state.order.qtyTotal : 0"
                :content="$store.state.order.orderType == $store.state.OT_TAKEOUT ? $store.state.order.qtyTotal : 0"
                color="accent"
                class="accentText--text"
                overlap
                offset-x="10"
                offset-y="10"
              >
                <v-icon>mdi-shopping</v-icon>
              </v-badge>
            </v-col>
            <v-row>
              <v-col>{{ $t("takeout") }}</v-col>
            </v-row>
            <v-col col-2> </v-col>
          </v-btn>
        </v-col>

        <v-col class="item" v-if="storeDeliveryVisible">
          <v-btn class="order-button" @click="deliveryOrder()">
            <v-col col-2>
              <v-badge
                :value="$store.state.order.orderType == $store.state.OT_DELIVERY ? $store.state.order.qtyTotal : 0"
                :content="$store.state.order.orderType == $store.state.OT_DELIVERY ? $store.state.order.qtyTotal : 0"
                color="accent"
                class="accentText--text"
                overlap
                offset-x="10"
                offset-y="10"
              >
                <v-icon>mdi-moped</v-icon>
              </v-badge>
            </v-col>
            <v-row>
              <v-col>{{ $t("delivery") }}</v-col>
            </v-row>
            <v-col col-2></v-col>
          </v-btn>
        </v-col>

        <v-col class="item" v-if="storeWaitlistVisible">
          <v-btn
            class="order-button"
            :disabled="$store.state.store.config.bookingWaitlistDeactivated"
            @click="booking(false)"
          >
            <v-col col-2>
              <v-icon>mdi-account-clock</v-icon>
            </v-col>
            <v-row>
              <v-col>{{ $t("booking.waitlist") }}</v-col>
            </v-row>
            <v-col col-2></v-col>
          </v-btn>
        </v-col>

        <v-col class="item" v-if="storeReserveVisible">
          <v-btn
            class="order-button"
            :disabled="$store.state.store.config.bookingReserveDeactivated"
            @click="booking(true)"
          >
            <v-col col-2>
              <v-icon>mdi-calendar-month</v-icon>
            </v-col>
            <v-row>
              <v-col>{{ $t("booking.reserve") }}</v-col>
            </v-row>
            <v-col col-2></v-col>
          </v-btn>
        </v-col>
      </v-row>

      <!-- </div> -->

      <div v-if="newsFeedsVisible">
        <div class="news-header">{{ $t("news") }}</div>
        <NewsFeedList></NewsFeedList>
      </div>
    </v-container>

    <v-footer
      v-if="
        $store.state.store != null &&
          $store.state.store.info != null &&
          $store.state.store.info.images != null &&
          $store.state.store.info.images.home != null
      "
      :absolute="$store.state.store.info.images.home.position == 'footer'"
    >
      <div v-for="(img, index) in $store.state.store.info.images.home.imgs" :key="index">
        <img
          :src="img.src"
          :class="$store.state.store.info.images.home.position == 'footer' ? 'home-image-footer' : 'home-image-bottom'"
          v-if="img.src != null && img.src != ''"
        />
      </div>
    </v-footer>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <AddShortcutToHomeScreen v-if="$store.state.rootName == 'StoreHome'"></AddShortcutToHomeScreen>

    <MemberBookingDialog ref="memberBookingDialog"></MemberBookingDialog>
  </div>
</template>

<script>
import AddShortcutToHomeScreen from "@/components/AddShortcutToHomeScreen.vue";
import LanguageIcon from "@/components/LanguageIcon.vue";
import MemberBookingDialog from "@/dialogs/MemberBookingDialog";
import NewsFeedList from "@/components/NewsFeedList.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    AddShortcutToHomeScreen,
    LanguageIcon,
    MemberBookingDialog,
    NewsFeedList,
  },

  data() {
    return {
      refreshing: false,
    };
  },

  mounted() {},

  activated() {
    console.log("Store Home activated");

    let timeStatus = this.getStoreTimeStatus(this.$store.state.store);
    this.$set(this.$store.state.store, "timeStatus", timeStatus);

    this.updateNewsFeeds();
  },

  computed: {
    ...mapGetters([
      "storeDineinVisible",
      "storeTakeoutVisible",
      "storeDeliveryVisible",
      "storeWaitlistVisible",
      "storeReserveVisible",
      "storeDineinAskTableName",
      "newsFeedsVisible",
    ]),

    showNavBack() {
      return this.$store.state.rootName == "Stores";
    },
  },

  methods: {
    onClickMenu() {
      this.$store.state.appBar.showDrawer = true;
    },

    dineinOrder() {
      this.toMenuPage(this.$store.state.OT_DINEIN);
    },

    takeoutOrder() {
      this.toMenuPage(this.$store.state.OT_TAKEOUT);
    },

    deliveryOrder() {
      this.toMenuPage(this.$store.state.OT_DELIVERY);
    },

    async booking(reserve) {
      let logined = this.$store.state.member != null;
      if (!logined) {
        logined = await this.$root.memberLoginDialog();
      }

      if (logined) {
        this.$refs.memberBookingDialog.open(reserve);
      }
    },

    async toMenuPage(orderType) {
      let confirmed = await this.confirmSwitchOrderType(orderType);

      if (confirmed) {
        this.refreshing = true;
        this.setOrderType(orderType)
          .then(() => {
            this.refreshing = false;

            if (this.$store.getters.categoryPosition == "center") this.navCategory();
            else this.navMenu();
          })
          .catch(() => {
            this.refreshing = false;
          });
      }
    },

    navCategory() {
      this.navName("MenuCategory");
    },

    navMenu() {
      this.navName("MenuFull");
    },
  },
};
</script>

<style lang="scss" scoped>
.store-info {
  margin-bottom: 20px;
  .store-name {
    //text-transform: uppercase;
    text-align: center;
    font-size: 1.1em;
    letter-spacing: 2px;
  }

  .store-address {
    margin-top: 20px;
    text-transform: uppercase;
    text-align: center;
    font-size: 0.75em;
    letter-spacing: 3px;
  }

  .store-business-hours {
    margin-top: 10px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    text-align: center;
    font-size: 0.85em;
    letter-spacing: 5px;
    line-height: 1.5;
    color: var(--v-accent-base);
    font-weight: bold;
    padding: 0px 20px;
  }

  .store-order-hours {
    @extend .store-business-hours;
    font-size: 0.8em;
  }
}

.order-button-container {
  .item {
    padding: 0px;
  }

  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (min-width: 600px) {
  .order-button-container {
    width: 450px;

    .item {
      min-width: 50%;
      flex-grow: 0;
    }

    .item:only-child {
      min-width: 100%;
    }
  }
}

.order-button {
  background-color: rgb(220, 220, 220);
  color: black;
  height: 60px !important;
  text-transform: capitalize;
  font-size: 1em;
  letter-spacing: 3px;
  border-radius: 60px;

  margin: 10px 0px;

  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 200px;

  .v-icon {
    color: var(--v-info-base) !important;
  }

  .order-button-cart {
    color: var(--v-accent-base) !important;
  }
}

.home-message {
  margin: 30px 30px;
  text-align: center;
  color: var(--v-primary-base);
  font-size: 0.8em;
  line-height: 2;
  letter-spacing: 3px;
}

.news-header {
  margin-top: 36px;
  margin-left: 12px;
  margin-right: 12px;
  //padding-bottom: 12px;
  padding-top: 24px;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.9em;
  letter-spacing: 5px;
  //border-top: 1px solid var(--v-border-base);
}

.v-footer {
  background-color: white;
  justify-content: center;
  padding: 0px;
}

.home-image-bottom {
  display: block;
  width: 100%;
}

.home-image-footer {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 100px;
  object-fit: cover;
}
</style>
